<!-- * RIGHT PANEL -->
<template>
    <v-col class="border-left-grey" :cols="GET_panelLayout.rightPanel" v-if="GET_panelLayout.show">
        <!-- //TODO add close grey bar-->
        <v-card style="height: 100% !important;" ref="popup" class="appbackground" flat tile >
            <div  class="grey darken-2 text-right appclosebar d-flex align-center" >
                <app-text category="dialog-title" class="ml-4">{{ GET_panelLayout.title }}</app-text>
                <v-spacer></v-spacer>                
                <appbutton class="pr-0" icon="icons8-multiply" type="grey darken-2" iconclass="white--text" @click.native="closeRightPanel" />
            </div>
            <div>
                <transition
                    name="custom-classes-transition"
                    enter-active-class="animate__animated animate__fadeIn animate__faster"
                    leave-active-class="animate__animated animate__fadeOut animate__faster"
                    mode="out-in">
                    <component :is="GET_panelLayout.dynamicComponent" :key="dynamicComponentKey"></component>
                </transition>
            </div>
        </v-card>
    </v-col>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'; // Map the Getters from the Vuex Store    
    export default {
        data: () => ({
            dynamicComponentKey: 0
        }),
        computed: {
            ...mapGetters({
                GET_panelLayout: 'GET_panelLayout', // Panel Layout used for Layout Structure
            }),
        },
        watch: {
            GET_panelLayout: {
                handler() {
                    this.dynamicComponentKey++; 
                }, deep: true
            },
        },
        methods: {
            ...mapActions({
                ACT_panelLayout: 'ACT_panelLayout',
            }),
            // UPDATE BREADCRUMBS
            updateBreadcrumbs() {
                var t = this;
                var breadcrumbs = [];
                var name = this.GET_panelLayout.title + 's';
                var path = this.GET_panelLayout.title.toLowerCase() + 's';
                breadcrumbs.push ({ name: name, path: path}) // Set the Main Path
                t.MIX_breadcrumbs(breadcrumbs);
            },
            closeRightPanel() {
                this.updateBreadcrumbs();
                this.ACT_panelLayout({ leftPanel: 12, rightPanel: 0, show: false, dynamicComponent: '' });
            }
        }
    }
</script>